import config from "@/config";

// Facebook Pixel 类型声明
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

/**
 * 触发 Facebook Pixel 自定义事件
 */
const trackFacebookEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, params);
  }
};

/**
 * 下载类型枚举
 */
export type DownloadType = "apk" | "qr" | "button" | "link" | "card";

/**
 * 触发下载点击统计
 */
export const trackDownloadClick = (downloadType: DownloadType = "apk") => {
  trackFacebookEvent("DownloadClick", {
    download_type: downloadType,
    timestamp: new Date().toISOString(),
  });
};

/**
 * 触发下载完成统计
 * 注意：由于浏览器安全限制，真正的下载完成事件很难精确捕获
 * 这个方法应该在用户点击下载后延迟调用，或者在下载页面加载时调用
 */
export const trackDownloadComplete = (downloadType: DownloadType = "apk") => {
  trackFacebookEvent("DownloadComplete", {
    download_type: downloadType,
    timestamp: new Date().toISOString(),
  });
};

/**
 * 执行下载操作
 * 可以在 onClick 事件中调用此方法
 */
export const handleDownload = (downloadType: DownloadType = "apk") => {
  // 触发点击统计
  trackDownloadClick(downloadType);

  // 创建隐藏的 iframe 来触发下载
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = config.downloadUrl;
  document.body.appendChild(iframe);

  // 下载完成后清理（延迟清理以确保下载开始）
  setTimeout(() => {
    document.body.removeChild(iframe);
    // 触发下载完成统计（延迟触发，给用户足够时间开始下载）
    trackDownloadComplete(downloadType);
  }, 2000);
};

/**
 * 获取下载链接
 */
export const getDownloadUrl = (): string => {
  return config.downloadUrl;
};
